<template>
  <v-container
    fill-height
    container--fluid
  >
    <upgrade-from-free
      v-if="upgradeDialog"
      :show-dialog="upgradeDialog"
      @closeUpgradeDialog="closeUpgradeDialog"
    />
    <v-layout
      wrap
    >
      <v-flex
        xs12
        md6
      >
        <v-card
          v-if="step == 'fill-form'"
          class="text-center pb-5"
        >
          <v-flex
            :class="!$vuetify.breakpoint.xs ? 'ml-11 mr-11' : ''"
          >
            <h3 class="mb-3">
              {{ $t("calculator.roiCalc") }}
            </h3>
            <div class="info p-5 pt-2 pb-2">
              <small>
                {{ $t("calculator.youCan") }}
              </small>
            </div>
          </v-flex>
        
          <v-flex
            exchange
            xs12
            mt-11
            mb-5
          >
            <center>
              <v-select
                v-model="exchange"
                :items="exchanges"
                :item-text="'name'"
                :item-value="'id'"
                :label="$t('calculator.chooseExchange')"
                dense
                @change="onChangeExchange"
              />
            </center>
          </v-flex>
          <v-flex
            v-if="exchange"
            xs12
            deposit
            mt-11
            mb-5
          >
            <center>
              <v-text-field
                v-model.trim="deposit"
                name="deposit"
                :label="$t('calculator.startDeposit')"
                maxlength="6"
                @blur="handleOnBlurDeposit()"
                @keypress="onlyForCurrency($event, deposit)"
              >
                <template v-slot:append>
                  {{ currency }}
                </template>
              </v-text-field>
            </center>
          </v-flex>
          <v-flex
            v-for="i in [1,2,3]"
            v-show="$apollo.loading"
            :key="'sk'+i"
            text-center
            mt-10
            mb-10
          >
            <v-card>
              <v-skeleton-loader
                type="list-item"
                class="mx-auto"
                width="100%"
              />
            </v-card>
          </v-flex>
          <v-flex v-if="rankings && exchange">
            <v-card
              v-for="(item, index) in calcItems"
              :key="item"
              class="calc-items mt-5"
            >
              <v-layout
                wrap
                align-center
              >
                <v-flex
                  v-if="!$vuetify.breakpoint.xs"
                  xs1
                  md1
                  mt-3
                >
                  <span>
                    {{ index + 1 }}.
                  </span>
                </v-flex>
                <v-flex
                  xs11
                  md4
                  pl-3
                  pr-3
                  mt-4
                >
                  <v-select
                    v-model="selectedProjects[item]"
                    :items="rankings.data"
                    :item-text="'project.name'"
                    :item-value="'project.id'"
                    :label="$t('calculator.chooseTraderBot')"
                    dense
                  />
                </v-flex>
                <v-flex
                  xs6
                  md3
                  pl-3
                  pr-3
                  mt-4
                >
                  <v-select
                    v-model="selectedPeriods[item]"
                    :items="periods"
                    :item-text="'desc'"
                    :item-value="'days'"
                    :label="$t('calculator.choosePeriod')"
                    dense
                  />
                </v-flex>
                <v-flex
                  xs5
                  md3
                  pl-3
                  pr-3
                  mt-4
                >
                  <v-select
                    v-model="selectedPcnts[item]"
                    :items="pcntDeposit"
                    :item-text="'text'"
                    :item-value="'id'"
                    :label="$t('calculator.perDoposit')"
                    dense
                  />
                </v-flex>
                <v-flex
                  v-if="index > 0"
                  xs1
                  md1
                  pt-2
                >
                  <v-icon
                    style="cursor:pointer;"
                    @click="removeItem(item)"
                  >
                    mdi-close-circle-outline
                  </v-icon>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex
            v-if="calcItems.length <= 11 && exchange"
            xs12
            text-left
            mt-4
            ml-3
            style="cursor:pointer;"
            @click="addMoreItems()"
          >
            <small>
              <b>{{ $t('calculator.addMore') }}</b>
              <v-icon>
                mdi-chevron-down
              </v-icon>
            </small>
          </v-flex>
          
          
          <v-divider class="mt-5 mb-5" />
          <v-flex
            v-if="error != null"
            mb-5
          >
            <small>{{ error }}</small>
          </v-flex>
          <v-btn
            class="primary"
            large
            @click="Calculate()"
          >
            {{ $t("calculator.calculateRoi") }}
          </v-btn>
        </v-card>
        <v-card
          v-if="step == 'loading'" 
          class="text-center pt-10 pb-10 pl-10 pr-10"
        >
          <v-layout
            wrap
            align-center
            style="height:500px"
          >
            <v-flex>
              <v-chip
                class="ma-5 info text-black"
                width="150"
                height="150"
                large
              >
                {{ progressValue.toFixed(0) }}%
              </v-chip><br>
              <b>{{ $t("calculator.loadingData") }}</b>
              <v-progress-linear
                v-model="progressValue"
                class="mt-3"
                color="purple"
              />
            </v-flex>
          </v-layout>
        </v-card>
        <v-card
          v-if="step == 'show-result'"
          class="calc-result"
        >
          <v-flex
            xs12
            class="text-center"
          >
            <h3 class="mb-0">
              {{ $t("calculator.yourResult") }}
            </h3>
            <span>{{ $t("calculator.compoundIntereset") }}</span>
          </v-flex>
          <v-card
            class="mt-4 mb-6"
          >
            <v-layout
              wrap
              align-center
            >
              <v-flex
                xs4
                :class="$vuetify.breakpoint.xs ? 'r-deposit-total-small' : 'r-deposit-total'"
                class="text-center "
              >
                <span>{{ $t("calculator.initDeposit") }}</span>
                <p class="mt-1">
                  {{ currency | renderSymbol }}
                  {{ result.init_deposit }}
                </p>
              </v-flex>
              <v-flex
                xs4
                :class="$vuetify.breakpoint.xs ? 'roi-total-small' : 'roi-total'"
                class="text-center mt-2"
              >
                <span :class="colorPnL(result.total_roi_pct)">{{ result.total_roi_pct }}%</span><br>
                <small> 
                  {{ currency | renderSymbol }}
                  {{ result.total_roi }}
                </small>
              </v-flex>
              <v-flex
                xs4
                :class="$vuetify.breakpoint.xs ? 'r-deposit-total-small' : 'r-deposit-total'"
                class="text-center"
              >
                <span>{{ $t("calculator.endDeposit") }}</span>
                <p class="mt-1">
                  {{ currency | renderSymbol }}
                  {{ result.end_deposit }}
                </p>
              </v-flex>
            </v-layout>
          </v-card>
          <v-layout
            v-for="(project, index) in result.projects"
            :key="index"
            wrap
            align-center
          > 
            <v-flex
              xs2
              md1
              :class="$vuetify.breakpoint.xs ? 'mt-2 mb-3' : 'pl-2'"
            >
              <v-avatar
                :tile="false"
                :size="40"
              >
                <v-img
                  :src="project.logo"
                  :lazy-src="project.logo"
                  max-height="40"
                  contain
                />
              </v-avatar>
            </v-flex>
            <v-flex
              :class="$vuetify.breakpoint.xs ? 'mt-2 mb-2' : 'pl-2'"
              xs8
              md3
              class="ticker"
            >
              <span class="text-primary">{{ project.ticker }}</span><br>
              <small>{{ project.name }}</small>
            </v-flex>
            <v-flex
              md3
              xs5
              :class="$vuetify.breakpoint.xs ? 'r-deposit-small' : 'r-deposit'"
              class="mt-1"
            >
              <span>{{ $t("calculator.initDeposit") }}</span>
              <p>
                {{ currency | renderSymbol }}
                {{ project.init_deposit }}
              </p>
            </v-flex>
            <v-flex
              md3
              xs4
              :class="$vuetify.breakpoint.xs ? 'r-deposit-small' : 'r-deposit'"
              class="mt-1"
            >
              <span>{{ $t("calculator.endDeposit") }}</span>
              <p>
                {{ currency | renderSymbol }}
                {{ project.end_deposit }}
              </p>
            </v-flex>
            <v-flex
              md2
              xs3
              class="roi"
            >
              <span :class="colorPnL(project.roi_pct)">{{ project.roi_pct }}%</span><br>
              <small>{{ $t("calculator.w"+project.period) }}</small>
            </v-flex>
            <v-flex xs12>
              <v-divider class="mt-2 mb-3" />
            </v-flex>
          </v-layout>
          <v-flex
            class="text-center pt-3 pb-2"
          >
            <v-btn
              class="primary"
              large
              @click="$router.push('/accounts')"
            >
              {{ $t("accounts.addAccButton") }}
            </v-btn>
            <br>
            <v-btn
              text
              small
              @click="startOver()"
            >
              {{ $t("calculator.startOver") }}
            </v-btn>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import REFLINK_RANKINGS_QUERY from "@/graphql/queries/ReflinkRankings.gql";
import CALCULATE_ROI_MUTATION from "@/graphql/mutations/CalculateRoi.gql";
import UpgradeFromFree from "@/views/Packs/partial/UpgradeFromFree.vue"

export default {
  name: "CalculatorRoi",
   components: {
    UpgradeFromFree
  },
  data() {
    return {
      params: {
        page: 1,
        count: 30,
        filter: null
      },
      exchange: null,
      exchanges: [{id: "binance", name: "Binance Futures"}, {id: "bitmex", name: "BitMEX"}],
      upgradeDialog: false,
      step: "fill-form",
      progressValue: 10,
      interval: 0,
      error: null,
      result: null,
      deposit: 0.5,
      currency: 'BTC',
      calcItems: [],
      periods: [
        {
          days: 30,
          desc: this.$t("calculator.last1Month")
        },
        {
          days: 60,
          desc: this.$t("calculator.last2Months")
        },
        {
          days: 91,
          desc: this.$t("calculator.last3Months")
        },
        {
          days: 182,
          desc: this.$t("calculator.last6Months")
        },
        {
          days: 365,
          desc: this.$t("calculator.last12Months")
        },
        {
          days: 730,
          desc: this.$t("calculator.last24Months")
        }
      ],
      selectedProjects: [],
      selectedPeriods: [],
      selectedPcnts: []
    }
  },
  computed: {
    pcntDeposit() {
      let pcnt = []
      for (var i = 10; i <= 100; i += 5) {
        pcnt.push({'id': i , 'text': `${i}%`})
      } 
      return pcnt
    },
  },
  watch: {
    progressValue (val, oldVal) {
      if (val >= 100 && this.result != null) {
        clearInterval(this.interval)
        this.step = 'show-result'
      }
    },
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    onChangeExchange() {
      if (this.exchange == 'bitmex') {
        this.deposit = 1
        this.currency = 'BTC'
        this.params.filter = 'bitmex'
      } else {
        this.deposit = 1000
        this.currency = 'USDT'
        this.params.filter = 'binance'
      }
      this.calcItems = []
      this.$apollo.queries.rankings.refresh()
    },
    Calculate() {
      this.error = null
      const pcntSum = this.selectedPcnts.reduce((a, b) => a + b, 0)
      if (pcntSum > 100) {
        this.error = this.$t('calculator.errorMoreThanHundert')
        return
      }
      this.step = 'loading'
      this.startBuffer()
      let projects = []
      this.calcItems.forEach(item => {
        projects.push({
          "project_id": this.selectedProjects[item],
          "period": this.selectedPeriods[item],
          "deposit_pct": this.selectedPcnts[item] 
        })
      });
      const params = {
        init_deposit: parseFloat(this.deposit),
        projects
      }
      this.$apollo
      .mutate({
        mutation: CALCULATE_ROI_MUTATION,
        variables: params
      })
      .then(data => {
        this.result = data.data.calculateRoi
        gtag('event', 'Calculate ROI Clicked', {
          'event_category': 'Package Sales',
          'event_label': 'Calculator',
        });
      });
    },
    handleOnBlurDeposit() {
      if (this.deposit == "" || this.deposit == 0 || this.deposit.slice(-1) == ".") {
        this.deposit = 0.5
      }
    },
    addMoreItems() {
      let item  = this.calcItems.length == 0 ? 1 : parseInt(this.calcItems.slice(-1)) + 1
      this.calcItems.push(item)
      this.selectedProjects[item] = this.rankings.data[this.calcItems.length-1].project.id
      this.selectedPeriods[item] = this.periods[2].days
      this.selectedPcnts[item] = this.pcntDeposit[4].id
    },
    removeItem(item) {
      const calcIndex = this.calcItems.indexOf(item);
      if (calcIndex > -1) {
        this.calcItems.splice(calcIndex, 1);
        delete this.selectedProjects[item]
        delete this.selectedPeriods[item]
        delete this.selectedPcnts[item]
      }
    },
    startBuffer () {
      clearInterval(this.interval)
      this.interval = setInterval(() => {
        this.progressValue += Math.random() * (25 - 5) + 5
      }, 400)
    },
    startOver() {
      this.step = 'fill-form'
      this.result = null
      this.progressValue = 10
      this.selectedProjects = []
      this.selectedPeriods = []
      this.calcItems = []
      this.selectedPcnts = []
      for (var i = 0; i <= 2; i++) {
        this.addMoreItems()
      } 
    },
    openUpgradeDialog() {
      this.upgradeDialog = true
      gtag('event', 'Upgrade Package Clicked', {
        'event_category': 'Package Sales',
        'event_label': 'Calculator',
      });
    },
    closeUpgradeDialog() {
      this.upgradeDialog = false
    }
  },
  apollo: {
    rankings: {
      query: REFLINK_RANKINGS_QUERY,
      fetchPolicy: "network-only",
      variables() {
        return this.params
      },
      skip() {
        return this.params.filter == null
      },
      result({loading }) {
        if (!loading) {
          for (var i = 0; i <= 2; i++) {
            this.addMoreItems()
          } 
        }
      }
    }
  }
}
</script>

<style lang="scss">
.calc-items {
  .v-label {
    font-size: 15px !important;
  }
  .v-select__selection {
    font-size: 15px !important;
    font-weight: 600 !important;
  }
}
.exchange {
  .v-label {
    margin-top:-8px;
  }
  .v-text-field {
    width: 300px;
  }
}
.deposit {
  .v-text-field {
    width: 300px;
    .v-input__append-inner {
      margin-top:25px;
    }
    .v-label {
      margin-top:-8px;
    }
    input {
      font-size: 30px !important;
      font-weight: 600 !important;
      max-height: inherit!important;
    }
  }
}
.calc-result {
  .ticker {
    span {
      font-weight: 700;
      
    }
    small {
      color: #7f97ab;
      font-weight: 400;
    }
  }
  .r-deposit {
     span {
      font-size: 12px;
      font-weight: 600;
      color: #7f97ab;
      text-transform: uppercase;
    }
    p {
      font-size: 15px;
      font-weight: 700;
    }
  }
  .r-deposit-small {
     span {
      font-size: 9px;
      font-weight: 600;
      color: #7f97ab;
      text-transform: uppercase;
    }
    p {
      font-size: 15px;
      font-weight: 700;
    }
  }
  .r-deposit-total {
    span {
      font-size: 12px;
      font-weight: 600;
      color: #7f97ab;
      text-transform: uppercase;
    }
    p {
      font-size: 22px;
      font-weight: 700;
      margin-bottom:0!important;
    }
  }
   .r-deposit-total-small {
    span {
      font-size: 9px;
      font-weight: 600;
      color: #7f97ab;
      text-transform: uppercase;
    }
    p {
      font-size: 16px;
      font-weight: 700;
      margin-bottom:0!important;
    }
  }
  .roi {
    span {
      font-size: 20px;
      font-weight: 400;
    }
    small {
      color: #7f97ab;
      font-weight: 400;
    }
  }
  .roi-total {
    span {
      font-size: 26px;
      font-weight: 700;
    }
    small {
      font-weight: 400;
    }
  }
  .roi-total-small {
    span {
      font-size: 20px;
      font-weight: 700;
    }
    small {
      font-weight: 400;
    }
  }
}
</style>